function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none"
}, React.createElement("path", {
  d: "M0 39V20h11z",
  fill: "#10a6e0"
}), React.createElement("path", {
  d: "M25 23H0V0h25z",
  fill: "#10a6e0"
}), React.createElement("g", {
  fill: "#fff"
}, React.createElement("path", {
  d: "M21 18L16.168 4H13l4.832 14zM8.168 18L13 4H9.83L5 18z"
})));

var SvgMapMarkerPva = function SvgMapMarkerPva(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 25 39"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjUgMzkiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0ibm9uZSI+PHBhdGggZD0ibTAgMzl2LTE5aDExeiIgZmlsbD0iIzEwYTZlMCIvPjxwYXRoIGQ9Im0yNSAyM2gtMTUuMTE4NDU4MDQtNC44NDg3NDg0OS01LjAzMjc5MzQ3di0yM2gyNXoiIGZpbGw9IiMxMGE2ZTAiLz48ZyBmaWxsPSIjZmZmIj48cGF0aCBkPSJtMjEgMTgtNC44MzIyMTQ4LTE0aC0zLjE2Nzc4NTJsNC44MzIyMTQ4IDE0eiIvPjxwYXRoIGQ9Im04LjE2Nzc4NTIzIDE4IDQuODMyMjE0NzctMTRoLTMuMTY5NjM2NjZsLTQuODMwMzYzMzQgMTR6Ii8+PC9nPjwvZz48L3N2Zz4=";
export { SvgMapMarkerPva as ReactComponent };